import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import colors, { white } from '../../../../../theme/colors';
import OfferFlagIcons from '../icons/OfferFlagIcons';
import { useOffers } from '../../../../../contexts/OffersContext';
import { isDarkMode } from '../../../../../utils/helpers';
import breakpoints from '../../../../../theme/material/breakpoints';

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const ContainerWrapper = styled('div')(({ topPosition, isVisible, variant }) => () => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    display: 'inline-flex',
    padding: '13px 10px',
    alignItems: 'center',
    borderRadius: 15,
    border: `3px solid ${
      ['decline', 'counter'].includes(variant) ? colors[theme].red.primary : colors[theme].green.primary
    }`,
    background: white,
    position: 'absolute',
    right: ['accept', 'request', 'offer'].includes(variant) ? 10 : 'auto',
    left: ['decline', 'counter'].includes(variant) ? 10 : 'auto',
    top: topPosition,
    opacity: isVisible ? 0.5 : 1,
    transition: 'top 0.5s ease-in-out, opacity 0.5s ease-in-out',
    [breakpoints.up(597)]: {
      right: ['accept', 'request', 'offer'].includes(variant) ? 20 : 'auto',
      left: ['decline', 'counter'].includes(variant) ? 20 : 'auto',
    },
  };
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const FlagTextWrapper = styled('div')(({ variant }) => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    color: ['decline', 'counter'].includes(variant) ? colors[theme].red.primary : colors[theme].green.primary,
    textAlign: 'center',
    fontSize: 22,
    fontStyle: 'normal',
    fontWeight: 700,
    letterSpacing: -0.44,
    textTransform: 'uppercase',
    marginLeft: 5,
  };
});

interface Props {
  onHidden: () => void;
}

const OneTapSwipeOfferFlag: React.FC<Props> = ({ onHidden }) => {
  const { oneTapOfferFlagVariant } = useOffers();
  const [topPosition, setTopPosition] = useState(30);
  const [isVisible, setIsVisible] = useState(true);

  const renderLabel = () => {
    switch (oneTapOfferFlagVariant) {
      case 'decline':
        return 'Declined';
      case 'accept':
        return 'Accepted!';
      case 'offer':
        return 'Offer!';
      case 'request':
        return 'Requested!';
      case 'counter':
        return 'Countered!';
      default:
        return '';
    }
  };

  useEffect(() => {
    const animationTimeout = setTimeout(() => {
      setTopPosition(10);
      setIsVisible(false);

      // Additional delay before hiding (adjust as needed)
      const hideTimeout = setTimeout(() => {
        onHidden();
      }, 1300);

      // Cleanup the timeout to avoid memory leaks
      return () => clearTimeout(hideTimeout);
    }, 0);

    // Cleanup the timeout to avoid memory leaks
    return () => clearTimeout(animationTimeout);
  }, [onHidden]);

  return (
    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    <ContainerWrapper topPosition={topPosition} isVisible={isVisible} variant={oneTapOfferFlagVariant}>
      <OfferFlagIcons variant={oneTapOfferFlagVariant} />
      <FlagTextWrapper
        // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
        variant={oneTapOfferFlagVariant}
      >
        {renderLabel()}
      </FlagTextWrapper>
    </ContainerWrapper>
  );
};

export default OneTapSwipeOfferFlag;
